import React from 'react'
import styled from 'styled-components'
import { Badge, BadgeProps } from 'components/common/Badge'
import { CaseStatus } from 'generated/types'

export const SentBadge = styled(Badge)`
  color: #0DAA7A;
  background-color: #B9E5D7;
  margin-right: 0;
  min-width: 73px;
`

export const OpenBadge = styled(Badge)`
  color: #DF9B06;
  background-color: #F7DA99;
  margin-right: 0;
  min-width: 73px;
`

export const ClosedBadge = styled(Badge)`
  color: #5E689B;
  background-color: #C9CCDD;
  margin-right: 0;
  min-width: 73px;
`

interface BadgeForStatusProps extends BadgeProps {
  status: CaseStatus
}

export const BadgeForStatus = (props: BadgeForStatusProps) => {
  const { status, ...rest } = props
  switch (status) {
    case CaseStatus.Open:
      return <OpenBadge {...rest}> Open </OpenBadge>
    case CaseStatus.Closed:
      return <ClosedBadge {...rest}> Closed </ClosedBadge>
    case CaseStatus.Sent:
      return <SentBadge {...rest}> Sent </SentBadge>
    default:
      return null
  }
}

export default {
  SentBadge,
  OpenBadge,
  ClosedBadge,
  BadgeForStatus,
}
